import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { PageSwitch } from "../../../components";
import AllBranch from "./modules/AllBranch";
import CreateBranch from "./modules/CreateBranch";
import ViewBranch from "./modules/ViewBranch";
// import { ButtonComp } from "../../../components";
import {
  useGetBranchesQuery,
  useDeleteBranchMutation,
} from "../../../store/admin/settings/branchSlice";
import { toast } from "react-hot-toast";
import { PageTitle } from "../modules/PageHeaders";
import { ModalCompAdvance } from "../../../components";
export default function SettingBranch() {
  const { isError, error } = useGetBranchesQuery();
  // eslint-disable-next-line no-unused-vars
  const [
    deleteBranch,
    { isError: isErrorDeleting, isLoading: isDeleting },
  ] = useDeleteBranchMutation();
  const [pageName, setPageName] = useState("Branch Management");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewBranchData, setViewBranchData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const removeBranch = async (branchId) => {
    try {
      const toastId = toast.loading("Deleting");
      const payload = await deleteBranch(branchId);
      const { data } = payload;
      if (data.status === false) {
        toast.error(data.message || "An error occured", {
          id: toastId,
        });
      }
      if (data.status === true) {
        toast.success(data.message || "Success", {
          id: toastId,
        });
      }
    } catch (error) {
      toast.error(error.message || "An error occured");
    }
  };

  const handleDeleteClick = (data) => {
    setSelectedBranch(data);
    setShowDeleteModal(true);
  };

  const handleViewClick = (data) => {
    setViewBranchData(data);
    setShowViewModal(true);
  };

  const confirmDelete = () => {
    if (selectedBranch) {
      removeBranch(selectedBranch.branchId);
      setShowDeleteModal(false);
      setSelectedBranch(null);
    }
  };

  const TableDropDown = [
    {
      name: "View",
      action: (data) => {
        handleViewClick(data);
      },
    },
    {
      name: "Edit",
      action: (data) => {
        navigate(`${location?.pathname}/${data?.branchId}`);
      },
    },
    {
      name: "Delete",
      action: (data) => {
        handleDeleteClick(data);
      },
    },
  ];

  // const usePage = [
  //   {
  //     name: "Branch Management",
  //     component: (
  //       <AllBranch
  //         TableDropDown={TableDropDown}
  //         onSubmit={() => setPageName(Create Branches"")}
  //       />
  //     ),
  //   },
  //   {
  //     name: "Create Branches",
  //     component: <CreateBranch onNext={() => {}} />,
  //   },
  // ];
  if (isError) {
    if (error.status === 401) {
      return navigate("/");
    }
    console.log(error);
  }

  const pageContent =
    pageName === "Branch Management" ? (
      <div>
        <div className="mb-4 text-end">
          <button
            type="button"
            className="bg-[var(--color-primary)] h-10 rounded px-4 py-2 text-white border-0 hover:scale-105"
            onClick={() => setPageName("Create Branches")}
          >
            Add New
          </button>
        </div>

        <PageTitle title={pageName} />
        <AllBranch
          TableDropDown={TableDropDown}
          onSubmit={() => setPageName("Create Branches")}
        />
      </div>
    ) : (
      <>
        <div className="mb-4 text-end">
          {/* <ButtonComp
            btnText={"View Branches"}
            onClick={() => setPageName("Branch Management")}
            btnClassName="bg-primary1  py-2 px-4 rounded text-white border-0"
          /> */}
          <button
            className="h-10 text-white rounded px-4 hover:scale-105 bg-new-primary"
            onClick={() => setPageName("Branch Management")}
          >
            View Branches
          </button>
        </div>
        <CreateBranch
          onNext={() => {}}
          onBack={() => setPageName("Branch Management")}
        />
      </>
    );

  const deleteModalContent = [
    {
      name: "Confirm Delete",
      component: (
        <div className="p-4 text-center">
          <h5 className="mb-3 text-danger">Delete Branch</h5>
          <p className="mb-4">
            Are you sure you want to delete "{selectedBranch?.name}"? This
            action cannot be undone.
          </p>
          <div className="d-flex gap-3 justify-content-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() => {
                setShowDeleteModal(false);
                setSelectedBranch(null);
              }}
            >
              Cancel
            </button>
            <button className="btn btn-danger px-4" onClick={confirmDelete}>
              Delete
            </button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <section className="px-4 px-lg-4 min-vh-100">
      <div className="py-1"></div>
      {pageContent}

      <ModalCompAdvance
        show={showDeleteModal}
        handleClose={() => {
          setShowDeleteModal(false);
          setSelectedBranch(null);
        }}
        arrayComp={deleteModalContent}
        centered
        size="md"
      />

      <ViewBranch
        branchData={viewBranchData}
        show={showViewModal}
        onHide={() => {
          setShowViewModal(false);
          setViewBranchData(null);
        }}
      />
      {/* <PageSwitch pageArray={usePage} pageName={pageName} /> */}
    </section>
  );
}
